import styled from "styled-components";
import { borderRadius, boxShadow } from "styled-system";
import { Flex } from "rebass";

export const Badge = styled(Flex)(borderRadius, boxShadow);
